<template>
  <el-dialog title="问卷发布记录" :visible.sync="historyDialogVisible" destroy-on-close width="750px">
    <template v-if="historyData.length > 0">
      <el-table :data="historyData" style="width: 100%" max-height="420">
        <el-table-column label="发布记录" header-align="center" width="110">
          <template slot-scope="{ row }">
            {{ ' 第 ' + row.no + ' 次发布' }}
          </template>
        </el-table-column>
        <el-table-column label="发布时间" header-align="center">
          <template slot-scope="{ row }">
            {{ row.inUse ? row.createTime + ' 至今 ' : row.createTime + ' 至 ' + row.updateTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="publisher"
          label="操作人"
          align="center"
          width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="address" label="操作按钮" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="toHistoryDetail(scope)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div v-if="historyData.length == 0">
      <el-empty slot="empty" description="当前问卷发布记录为空" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="historyDialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    historyData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      historyDialogVisible: false
    }
  },
  methods: {
    toHistoryDetail(scope) {
      this.$emit('toHistoryDetail', scope)
    },
    indexMethod(index) {
      return `第${index + 1}次发布`
    }
  }
}
</script>
<style scoped>
>>> .el-dialog__body {
  padding: 30px 20px 0px;
}
</style>
